export const environment = {
  production: false,
  apiURL: 'https://dev.shohay.net',
  envName: 'development',
  shohayBlogToken:
    '7dab7a72ed958078cd7b984e046be18a44e5cf4d1de2d1bcee781c47fc1926c0917039407f29040f45886089147a2c61ff9e8c392b45c029bd519ef4474945893f0ffb7873006abd7738185e67d006de7a5f52be112781dfd2bad9f8acf7ad0bc17adac14517c667df6c10c1360c81b7b818158c6bf9232917f82560020b0a08',
  firebaseConfig: {
    apiKey: 'AIzaSyBX9iJHQJJmSrhEFInEa1bA8g7zn84Roas',
    authDomain: 'shohay-notification.firebaseapp.com',
    projectId: 'shohay-notification',
    storageBucket: 'shohay-notification.firebasestorage.app',
    messagingSenderId: '431828719944',
    appId: '1:431828719944:web:ddafa772195cad782fbb7d',
    measurementId: 'G-5WZH4XHGRK',
    vapidKey:
      'BBqHAYFveJ23aVE0GJcxaupqW4oh_nE7iOoRn9XX9YQG3l9rmQoKlaNPCIsZ3Jmly5ebd2SbtXHp9_w251XZAfw',
  },
};
